export const bonuses = [
  {
    n: 1,
    title: "Speech Sound Picture Card Collection",
    tagline: "Organize visual resources for speech sound practice.",
    body: [
      "This supplementary collection includes picture-based resource examples and word organization sheets that can help you prepare activities around relevant speech sounds.",
      "Use the materials as starting points for selecting and organizing appropriate practice resources.",
    ],
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/3c9UMrtd136FeTeuBAXhgp/BONUS_1_ARTICULATION-EN.png",
    badge: "bg-blush text-white",
  },
  {
    n: 2,
    title: "Articulation Session Activity Planner",
    tagline: "Prepare your activity sequence before each session.",
    body: [
      "This planning workbook includes activity organizers, session preparation sheets, and templates for recording the resources you intend to use.",
      "It helps bring your session planning information together in one place.",
    ],
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/bPQfBNdRGnsz2VsT14x5SR/BONUS_2_ARTICULATION-EN.png",
    badge: "bg-mint text-white",
  },
  {
    n: 3,
    title: "Speech Sound Word List Workbook",
    tagline: "Keep your word examples and practice materials organized.",
    body: [
      "This workbook includes templates for organizing word examples, recording relevant speech sound contexts, and preparing materials for individualized practice activities.",
    ],
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/heynVcJ3CvSVsjZ6saXi3U/BONUS_3_ARTICULATION-EN.png",
    badge: "bg-coral text-white",
  },
  {
    n: 4,
    title: "Family Home Practice Organizer",
    tagline: "Make activity information easier to prepare and share.",
    body: [
      "This resource includes family-friendly activity information sheets, home practice organizers, and templates for documenting instructions provided by the professional.",
      "The materials can be adapted to the child's needs and the recommendations made by the treating clinician.",
    ],
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/pUqWrkKax4bb8xg2NGird1/BONUS_4_ARTICULATION-EN.png",
    badge: "bg-sun text-navy",
  },
  {
    n: 5,
    title: "Speech Sound Documentation & Follow-Up Pack",
    tagline: "Keep your records and next steps organized.",
    body: [
      "This supplementary pack includes session note templates, observation records, review worksheets, and follow-up planning tools.",
      "Use it to organize information gathered throughout your professional workflow.",
    ],
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/drQ3g2BHYTL8pYDikDMVPh/BONUS_5_ARTICULATION-EN.png",
    badge: "bg-lilac text-white",
  },
];
